import { Component, OnInit } from "@angular/core";
import { TemplateService } from "src/app/services/system-config/template/templates.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Title } from "@angular/platform-browser";
import { AppCoreService } from "src/app/services/app-core.service";

@Component({
  selector: "app-templates",
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss']
})
export class TemplatesComponent implements OnInit {

  templates: any[] = [];
  Invoice: any[] = [];
  AWB: any[] = [];
  Manifest: any[] = [];
  CommercialInvoice: any[] = [];
  DRS: any[] = [];
  BoxLabel: any[] = [];
  Label: any[] = [];

  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };

  selectedInvoiceTemplate: any;
  selectedAWBTemplate: any;
  selectedManifestTemplate: any;
  selectedCommercialTemplate: any;
  selectedDRSTemplate: any;
  selectedBoxTemplate: any;
  selectedLabelTemplate: any;
  _data: any;

  constructor(
    private templateService: TemplateService,
    private ngxLoaderService: NgxUiLoaderService,
    private appCoreService : AppCoreService,
    private titleService: Title
  ) {
    titleService.setTitle('Templates');
  }

  ngOnInit(): void {
    this.loadTemplates();
    this.checkPermission();
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData(); 
    const permission = userData.config.filter(x => x.categoryname === 'Templates');
    if (permission.length) {
        this.permConfig.isViewAllowed = permission[0].view;
        this.permConfig.isAddAllowed = permission[0].add;
        this.permConfig.isEditAllowed = permission[0].edit;
        this.permConfig.isDeleteAllowed = permission[0].delete;
    }
}

  loadTemplates(refresh = false) {
    this.ngxLoaderService.start();
    try {
      this.templateService.getAllTemplates({ refresh: refresh }).subscribe((res) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.templates = res.data;
          this.Invoice = this.templates.filter(template => template.category === 'Invoice');
          this.AWB = this.templates.filter(template => template.category === 'AWB');
          this.Manifest = this.templates.filter(template => template.category === 'Manifest');
          this.CommercialInvoice = this.templates.filter(template => template.category === 'Commercial Invoice');
          this.DRS = this.templates.filter(template => template.category === 'DRS');
          this.BoxLabel = this.templates.filter(template => template.category === 'Box Label');
          this.Label = this.templates.filter(template => template.category === 'Label');
          this.getSelectedTemplateId();
        } else {
          this.ngxLoaderService.stop();
        }
      });
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  getSelectedTemplateId() {
    this.ngxLoaderService.start();
    try {
      const InvoiceDefaultTemplate = this.Invoice.find((item: any) => item.userdefault);
      const systemInvoiceDefaultTemplate = this.Invoice.find((item: any) => item.systemdefault);

      const AwbDefaultTemplate = this.AWB.find((item: any) => item.userdefault);
      const systemAwbDefaultTemplate = this.AWB.find((item: any) => item.systemdefault);

      const ManifestDefaultTemplate = this.Manifest.find((item: any) => item.userdefault);
      const systemManifestDefaultTemplate = this.Manifest.find((item: any) => item.systemdefault);

      const CommercialInvoiceDefaultTemplate = this.CommercialInvoice.find((item: any) => item.userdefault);
      const systemCommercialInvoiceDefaultTemplate = this.CommercialInvoice.find((item: any) => item.systemdefault);

      const DRSDefaultTemplate = this.DRS.find((item: any) => item.userdefault);
      const systemDRSDefaultTemplate = this.DRS.find((item: any) => item.systemdefault);

      const BoxDefaultTemplate = this.BoxLabel.find((item: any) => item.userdefault);
      const systemBoxDefaultTemplate = this.BoxLabel.find((item: any) => item.systemdefault);

      const LabelDefaultTemplate = this.Label.find((item: any) => item.userdefault);
      const systemLabelDefaultTemplate = this.Label.find((item: any) => item.systemdefault);

      let InvoicedefaultId = InvoiceDefaultTemplate ? InvoiceDefaultTemplate.id : systemInvoiceDefaultTemplate ? systemInvoiceDefaultTemplate.id : null;
      this.selectedInvoiceTemplate = InvoicedefaultId;

      let AWBdefaultId = AwbDefaultTemplate ? AwbDefaultTemplate.id : systemAwbDefaultTemplate ? systemAwbDefaultTemplate.id : null;
      this.selectedAWBTemplate = AWBdefaultId;

      let ManifestdefaultId = ManifestDefaultTemplate ? ManifestDefaultTemplate.id : systemManifestDefaultTemplate ? systemManifestDefaultTemplate.id : null;
      this.selectedManifestTemplate = ManifestdefaultId;

      let CommercialdefaultId = CommercialInvoiceDefaultTemplate ? CommercialInvoiceDefaultTemplate.id : systemCommercialInvoiceDefaultTemplate ? systemCommercialInvoiceDefaultTemplate.id : null;
      this.selectedCommercialTemplate = CommercialdefaultId;

      let DRSdefaultId = DRSDefaultTemplate ? DRSDefaultTemplate.id : systemDRSDefaultTemplate ? systemDRSDefaultTemplate.id : null;
      this.selectedDRSTemplate = DRSdefaultId;

      let Boxid = BoxDefaultTemplate ? BoxDefaultTemplate.id : systemBoxDefaultTemplate ? systemBoxDefaultTemplate.id : null;
      this.selectedBoxTemplate = Boxid;

      let Labelid = LabelDefaultTemplate ? LabelDefaultTemplate.id : systemLabelDefaultTemplate ? systemLabelDefaultTemplate.id : null;
      this.selectedLabelTemplate = Labelid;
      this.ngxLoaderService.stop();
    }
    catch (e) {
      console.error(e);
    }
  }

  previewImage(id: number) {
    const imageUrl = this.templates[id - 1].filepathurl;
    window.open(imageUrl, '_blank');
  }

  setDefault(id: any, category: string) {
    this.templateService.setDefault({ id: id, category: category }).subscribe((res) => {
      if (res && res.success) {
        this.loadTemplates(true);
      }
    });
  }
}